// src/components/PropertyPage/Utils/PropertyGallerySkeleton.js
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PropertyGallerySkeleton = () => {
  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <div className="PropertyGallerySkeleton">
        {/* Imagen principal grande */}
        <div className="PropertyGallerySkeleton__main">
          <Skeleton height={400} />
        </div>
        
        {/* Miniaturas */}
        <div className="PropertyGallerySkeleton__thumbnails">
          {Array(4).fill().map((_, index) => (
            <div key={index} className="PropertyGallerySkeleton__thumbnail">
              <Skeleton height={80} />
            </div>
          ))}
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default PropertyGallerySkeleton;